import React from 'react';

import { ITableColumnCellProps } from './TableColumnCell.types';

import './TableColumnCell.scss';

const TableColumnCell = ({
	textList,
	onClick,
	onDoubleClick,
}: ITableColumnCellProps) => {
	return (
		<div
			className={'f5gTableColumnCellContainer'}
			onClick={onClick}
			onDoubleClick={onDoubleClick}
		>
			{textList.map((text, index) => {
					return (
						<span key={`f5gTableColumnCell_${index}_${text}`}>
						{text}
					</span>
					);
				},
			)}
		</div>
	);
};

export default TableColumnCell;
